<script>
  import { user, userRol } from "../stores/user";
  import { navigate } from "svelte-routing";
  import { onMount } from "svelte";
  import { auth } from "../firebase";
  import { panelController,dataReset } from "../stores/service";
  import { writable } from "svelte/store";

  document.title = "Rantingg | Perfil";

  let userr = {
    name: 'John Doe',
    email: 'john.doe@example.com',
    profilePicture: 'https://via.placeholder.com/150' // Puedes reemplazarlo con la URL de la imagen de perfil del usuario
  };

  const cerrarSesion = () => {
    
    $panelController = dataReset();
    auth.signOut();
    user.setUser(null);
    $panelController.viewLogin.roluser = 4;

    window.location.reload();
  };

  const home = () => {
    navigate("/", { replace: true });
    /* console.log("Cerrar Seccion"); */
  };

  onMount(async () => {

    switch ($panelController.viewLogin.roluser) {
      case 1:
        break;
      case 3:
        if ($panelController.viewPerfil.logOut) {
          cerrarSesion();
        }
        panelController.set(datamost);
        $panelController.firebase.load = false;
        await user.current();
        $panelController.viewLogin.roluser = 0;
        window.location.reload();
        break;
        
      default:
        navigate("/", { replace: true });
        break;
    }
  });
</script>

{#if $user}
<div class="profile-card">
  <img src={$user.photoURL} alt="Profile Picture" class="profile-picture">
  <div class="profile-name">{$user.displayName}</div>
  <div class="profile-email">{$user.email}</div>
  <div class="row">
    <button class="btn btn-primary btn-block" on:click={cerrarSesion}
        >Salir</button
      >
  </div>
</div>
{/if}

 

<style>
  .profile-card {
    max-width: 400px;
    margin: auto;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    background: white;
    text-align: center;
  }

  .profile-picture {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    object-fit: cover;
    margin-bottom: 20px;
  }

  .profile-name {
    font-size: 1.5em;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .profile-email {
    font-size: 1em;
    color: gray;
  }
</style>



